import * as React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { TeamSummaryResource } from '../../../TeamsSummaryStore/Types';
import * as style from '../../TeamSummary/style.module.css';
import { Maybe } from 'maybeasy';
import { NonEmptyList } from 'nonempty-list';
import { TeamMemberResource } from '../../../TeamsStore/Types';

interface Props {
  teamSummaryResource: TeamSummaryResource;
  overflowedMembers: Maybe<NonEmptyList<TeamMemberResource>>;
}

const CommunityMembersCountAfterTruncate: React.FC<Props> = ({
  teamSummaryResource,
  overflowedMembers,
}) => {
  return (
    <>
      {overflowedMembers
        .map((overflowedMembers) => {
          const count = overflowedMembers.toArray().length;
          return (
            <span className={style.overflowLink}>
              <Link
                to={`/teams/${teamSummaryResource.payload.id}`}
                data-test-team-link="Team"
                aria-label={`View ${count} more community members`}
              >
                {`+${count}`}
              </Link>
            </span>
          );
        })
        .getOrElse(() => (
          <></>
        ))}
    </>
  );
};

export default observer(CommunityMembersCountAfterTruncate);
